module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>clock</title><path d=\"M24.89,27.74l12.18-5.9a1.4,1.4,0,1,0-1.23-2.52L25.49,24V11.73a1.45,1.45,0,0,0-2.9,0l0,14.67A1.54,1.54,0,0,0,24.89,27.74Z\"></path><path d=\"M24.93,1A23.92,23.92,0,1,0,48.86,24.92,23.93,23.93,0,0,0,24.93,1Zm0,45.12A21.19,21.19,0,1,1,46.13,24.92,21.19,21.19,0,0,1,24.93,46.12Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/clock.svg
// module id = 494
// module chunks = 1